
import { defineComponent } from 'vue'
import { format, endOfDay } from 'date-fns'
import { faEdit, faSearch, faSave } from '@fortawesome/free-solid-svg-icons'
import { PrimaryButton, Card, Form, Input, Table } from '@design-system/ui'
import CustomInput from '../components/input/Input.vue'
import Toast from '../components/Toast.vue'
import SessionService from '../SessionService'
import api from '@/services/api'
import { ListSoftwareHousesDTO } from '@/interfaces/ListSoftwareHousesDTO'
import utils from '@/utils'

export default defineComponent({
  name: 'SoftwareHouses',
  components: {
    PrimaryButton,
    Card,
    Form,
    Input,
    CustomInput,
    Toast,
    Table
  },
  data () {
    return {
      link: '',
      createLink: '',
      loading: false,
      loadingSoftwareHouse: false,
      inviteModal: false,
      linkModal: false,
      allSoftwareHouses: [],
      buttonIcons: {
        search: {
          icon: faSearch
        },
        save: {
          icon: faSave
        }
      },
      softwareHouses: [],
      searchSoftwareHouseText: '',
      startFilter: '',
      endFilter: '',
      filterDateStartErrorMessage: '',
      filterDateEndErrorMessage: '',
      filterDateErrorMessage: '',
      softwareHouse: {},
      newMediatorFee: '',
      clicked: '',
      error: '',
      edit: faEdit,
      companyForm: {
        RazaoSocial: null,
        CNPJ: null,
        Email: null,
        MediatorFee: null
      },
      formValidation: {
        MediatorFee: '',
        CNPJ: '',
        Email: '',
        RazaoSocial: ''
      },
      buttonNewCompany: true,
      message: '',
      hidden: true,
      timeSeen: 20000,
      copied: 'Copiar link'
    }
  },
  mounted () {
    const session = new SessionService()
    if (!session.rootAccess()) {
      this.$router.push('/painel')
    }
    this.SOFTWARE_HOUSE_CNPJ = session.cnpj()
    this.getData()

    this.link = utils.checkUrl()
  },
  methods: {
    async getData () {
      this.loading = true
      api.get<ListSoftwareHousesDTO[]>('/software-houses', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })
        .then(response => {
          this.allSoftwareHouses = response.data
          this.softwareHouses = this.allSoftwareHouses
          this.loading = false
          setTimeout(() => {
            var evt = new CustomEvent('list')
            window.dispatchEvent(evt)
          }, 1)
        })
        .catch(() => {
          this.loading = false
        })
    },

    closeModal () {
      this.softwareHouseModal = false
      this.linkModal = false
    },

    searchSoftwareHouses () {
      this.filterDateErrorMessage = ''

      if (this.startFilter && !this.endFilter) {
        this.filterDateEndErrorMessage = 'Data não informada'
      }

      if (!this.startFilter && this.endFilter) {
        this.filterDateStartErrorMessage = 'Data não informada'
      }

      if (this.startFilter && this.endFilter && this.startFilter > this.endFilter) {
        this.filterDateStartErrorMessage = 'Data inicial não pode ser maior que a data final'
        this.filterDateEndErrorMessage = 'Data final não pode ser menor que a data final'
      }

      if (this.endFilter > new Date()) {
        this.filterDateEndErrorMessage = 'Não é possível buscar dados futuros'
      }

      if (this.filterDateStartErrorMessage || this.filterDateEndErrorMessage) {
        return
      }

      let softwareHouses = this.allSoftwareHouses

      if (!this.searchSoftwareHouseText && (!this.startFilter || !this.endFilter)) {
        this.softwareHouses = softwareHouses
        return
      }

      this.loading = true
      if (this.searchSoftwareHouseText) {
        const softwareHouseCnpj = this.searchSoftwareHouseText.replaceAll('/', '')
          .replaceAll('.', '')
          .replaceAll('-', '')
        softwareHouses = softwareHouses.filter((softwareHouse) => {
          const cnpjWithoutMask = softwareHouse.cnpj.replaceAll('/', '')
            .replaceAll('.', '')
            .replaceAll('-', '')
          return softwareHouse.razaoSocial.toLowerCase().includes(this.searchSoftwareHouseText) ||
            softwareHouse.nomeFantasia.toLowerCase().includes(this.searchSoftwareHouseText.toLowerCase()) ||
            cnpjWithoutMask.includes(softwareHouseCnpj)
        })
      }

      if (this.startFilter && this.endFilter) {
        softwareHouses = softwareHouses.filter((softwareHouse) => {
          if (softwareHouse.dataAtivacao) {
            const dataAtivacao = new Date(softwareHouse.dataAtivacao)
            const endFilterEndDay = endOfDay(this.endFilter)
            return dataAtivacao >= this.startFilter && dataAtivacao <= endFilterEndDay
          }
        })
      }

      this.softwareHouses = softwareHouses
      this.loading = false
    },

    formatDate (date: string) {
      const dateNew = new Date(date)
      return format(dateNew, 'dd/MM/yyyy')
    },

    async getSoftwareHouse (cnpj: string) {
      this.loadingSoftwareHouse = true
      this.clicked = this.softwareHouses.findIndex(elem => elem.cnpj === cnpj)
      try {
        const softwareHouseFromShop = await api.get(`/shop/software-houses/${cnpj}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        this.softwareHouse = softwareHouseFromShop.data
      } catch {
        const softwareHouseFromDynamo = await api.get(`/software-houses/${cnpj}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        this.softwareHouse = softwareHouseFromDynamo.data
      }
      this.softwareHouseModal = true
      this.loadingSoftwareHouse = false
    },

    async generateLink () {
      Object.keys(this.companyForm).forEach((field) => {
        if (['CNPJ', 'Email', 'RazaoSocial'].includes(field) && !this.companyForm[field]) {
          this.formValidation[field] = 'Este campo é obrigatório.'
        }

        if (field === 'MediatorFee') {
          const mediatorFee = this.companyForm[field].replaceAll(
            '.',
            ''
          )
            .replaceAll(',', '.')
            .replaceAll('R$ ', '')

          if (parseFloat(mediatorFee) <= 0) {
            this.formValidation[field] = 'A tarifa padrão deve ser maior que zero.'
          }
        }

        utils.validate(
          field,
          this.companyForm,
          this.formValidation,
          this.clientType,
          true
        )
      })

      if (Object.keys(this.formValidation).length > 0) {
        return
      }

      try {
        this.buttonNewCompany = false
        await api.post('/pre-register/software-house',
          {
            cnpj: this.companyForm.CNPJ
              .replaceAll('/', '')
              .replaceAll('.', '')
              .replaceAll('-', ''),
            email: this.companyForm.Email,
            razaoSocial: this.companyForm.RazaoSocial,
            mediatorFee: parseFloat(this.companyForm.MediatorFee.replaceAll(',', '.').replaceAll('R$ ', ''))
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }).then((response) => {
          this.inviteModal = false
          this.linkModal = true
          this.handleLinkGeneration(response.data.uuid)
          this.buttonNewCompany = true
        })
        this.buttonNewCompany = true
        this.getData()
      } catch (error) {
        this.hidden = false
        this.buttonNewCompany = true
        this.message = error.response.data.error_messages[0] ? error.response.data.error_messages[0] : 'Erro ao cadastrar Software House.'
        setTimeout(() => { this.hidden = true }, this.timeSeen)
      }
    },

    handleLinkGeneration (uuid: string) {
      this.createLink = `${this.link}/softwarehouse/${uuid}`
    },

    handleEdit (cnpj: string) {
      this.$router.push(`/software-houses/${cnpj.replace(/\D/g, '')}/edit`)
    },

    changeField (index, value) {
      this.companyForm[index] = value

      utils.validate(
        index,
        this.companyForm,
        this.formValidation,
        this.clientType,
        true
      )
    },

    changeFilterDate (index, value) {
      const fieldName = index.target?.name || index
      this[fieldName] = value

      this.filterDateStartErrorMessage = ''
      this.filterDateEndErrorMessage = ''
    },

    hide () {
      this.hidden = true
    },

    copyToClipboard () {
      const el = document.createElement('textarea')
      el.value = this.createLink
      document.body.appendChild(el)
      const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      if (selected) {
        document.getSelection().removeAllRanges()
        document.getSelection().addRange(selected)
      }
      this.copied = 'Link copiado com sucesso'
    }
  },
  beforeMount () {
    this.$store.commit('changeActiveMenu', 1)
  }
})
